import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, Optional, ViewChild, } from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { DateTimeModel, DwComponent, DwComponentType, DwControlType, DwEvent, DwEventService, DwItemAttribute, DwOrmDataChangeEvent, DwOrmDataService, DwQueryMdAttribute, DwQueryMetaData, DwStyleManagerService, areEqual, convertToIsoDateTime, dateTimeAddDays, formatDateTime, formatDateTimeToLocal, getMomentValue } from '@devwareapps/devware-cap';
import { CalendarRepositoryService } from '../../../calendar/services/calendar-repository.service';
import { CalendarOptions } from '../../../calendar/models/calendar-options.model';
import { CalendarWeekDayEvent } from '../../../calendar/models/calendar-weekday-event.model';
import { EventSearchRequestDTO } from '../../../calendar/models/event-search-request.model';
import { CalendarEventDTO, CalendarEventStatus } from '../../../calendar/models/calendar-event.model';
import { CalendarDTO } from '../../../calendar/models/calendar.model';
//import { FullCalendar } from 'primeng/fullcalendar';

//import { OptionsInput } from '@fullcalendar/core';
//import { OptionsInput } from '@fullcalendar/core';

import * as moment_ from 'moment';
const moment = moment_;

import { EventDateTimeDTO } from '../../../calendar/models/event-data-time.model';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { AppMetaData, AppMetaDataItemNames, CalendarReferenceEntity, CheckRideRequestCalendarQueryEntity, CheckRideRequestEntity, CheckRideRequestSubStatusAllItems, PilotExaminerEntity, ScheduleBlockEntity, ScheduleBlockItemEntity, ScheduleBlockItemTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { CalendarClickEvent, CalendarClickEventType } from '../../../calendar/models/calendar-click-event.model';
import { Router } from '@angular/router';
import { CalendarConfig } from '../../../calendar/models/calendar-config.model';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { ScheduleBlockCalendarEvent } from '../../../schedule-blocks/models/schedule-block-calendar-event.model';
import { CalendarDataType, CalendarExtendedData } from '../../../calendar/models/calendar-extended-data.model';
import { DayPilot } from 'daypilot-pro-angular';
import { ScheduleBlockService } from '../../../schedule-blocks/services/schedule-block.service';
import { ScheduleBlockDateRef } from '../../../schedule-blocks/models/schedule-block-date-ref.model';
import { CalendarWeekdayComponent } from '../../../calendar/components/calendar-weekday/calendar-weekday.component';
import { CalendarControllerService, CalendarControllerToken } from '../../services/interfaces/calendar-controller-service.interface';
import { CheckrideReferenceInfo } from '../../../examiner/models/checkride-reschedule-info.model';

@Component({
  selector: 'app-booking-calendar',
  templateUrl: './booking-calendar.component.html',
  styleUrls: ['./booking-calendar.component.scss']
})
export class BookingCalendarComponent implements OnInit, OnDestroy {

  @Input() compactView: boolean = false;
  @Input() hideActionBar: boolean = false;

  textboxControlType: DwControlType = DwControlType.Textbox;
  allCalendars: CalendarDTO[] = [];
  usedCalendars: CalendarDTO[] = [];
  primaryCalendar: CalendarDTO;

  selectedCheckRide: CheckRideRequestCalendarQueryEntity;
  queryMetaData: DwQueryMetaData;
  calendarReference: CalendarReferenceEntity;
  selectedEvent: CalendarWeekDayEvent;
  calendarConfig: CalendarConfig = {};
  //examiner: PilotExaminerEntity;
  selectedBlockItem: ScheduleBlockCalendarEvent;
  mainEvents: CalendarWeekDayEvent[];
  currentEventSearchRequest: EventSearchRequestDTO;
  calendarItemConvertedEvents: CalendarWeekDayEvent[];
  ignoreNextScheduleUpdate: boolean;

  useBlockBooking: boolean = false;
  allowCalendarIntegration: boolean = false;
  calendarSettingsOpen: boolean = false;

  @ViewChild("calendar", { static: false }) calendar: CalendarWeekdayComponent;
  bubbleTestHtml: any;
  initLoadComplete: boolean;

  constructor(protected calendarRepositoryService: CalendarRepositoryService,
    @Optional() @Inject(CalendarControllerToken) protected calendarControllerService: CalendarControllerService,
    //protected examinerRepositoryService: ExaminerRepositoryService,
    protected scheduleBlockService: ScheduleBlockService,
    protected router: Router,
    protected dwEventService: DwEventService,
    protected cdr: ChangeDetectorRef,
    protected dateTimeUtilService: DateTimeUtilService,
    //protected dwStyleManagerService: DwStyleManagerService
  ) { }

  options: CalendarOptions;

  events: CalendarWeekDayEvent[] = [];
  tempBlockEvents: CalendarWeekDayEvent[] = [];

  eventSearchRequests: EventSearchRequestDTO[] = [];

  subscriptions: Subscription[] = [];
  pendingCalendarSyncRefreshes = new Map<number, any[]>();

  initComplete = false;

  ngOnInit(): void {
    this.setCalendarOptions();

    this.setupComponent();

    this.setupChangeEvents();
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }

    for (const timers of this.pendingCalendarSyncRefreshes.values()) {
      timers.forEach(timer => clearTimeout(timer));
    }
    this.pendingCalendarSyncRefreshes.clear();
  }

  setupChangeEvents() {
    this.subscriptions.push(
      this.dwEventService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.CheckRideRequest), false, false)
        .subscribe((event: DwEvent) => {
          if (this.initLoadComplete) {
            this.handleDataUpdate(event);
          }
        }));

    this.subscriptions.push(
      this.dwEventService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.ScheduleBlock), false, false)
        .subscribe((event: DwEvent) => {
          if (this.initLoadComplete) {
            this.handleDataUpdate(event);
          }
        }));

    this.subscriptions.push(
      this.dwEventService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.ScheduleBlockItem), false, false)
        .subscribe((event: DwEvent) => {
          if (this.initLoadComplete) {
            this.handleDataUpdate(event);
          }
        }));
  }

  handleDataUpdate(event: DwEvent<any>) {
    if (!this.initComplete) {
      return;
    }

    if (event.topic == DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.ScheduleBlock) ||
      event.topic == DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.ScheduleBlockItem)
    ) {
      return;

      // Check if event has already been handled
      if (this.ignoreNextScheduleUpdate) {
        this.ignoreNextScheduleUpdate = false;

        return;
      }
    }

    this.events = [];
    this.mainEvents = [];
    this.tempBlockEvents = [];
    this.currentBlockDates = [];
    this.eventSearchRequests = [];
    this.blockEvents = [];

    this.loadEventRange(this.options.startDate);
  }

  protected setupComponent() {
    const queryMetaDataOb = this.calendarRepositoryService.getCheckRideRequestQueryMetaData();
    const calendarRefOb = this.calendarControllerService.getCurrentCalendarRef();
    const setupDataOb = this.calendarControllerService.loadSetupData();

    combineLatest([queryMetaDataOb, calendarRefOb, setupDataOb])
      .subscribe(([queryMetaData, calendarRef, setupData]) => {

        // Run after the setupData has loaded since these methods might rely on that data being loaded (like useBlockBooking)
        this.useBlockBooking = this.calendarControllerService.useBlockBooking();
        this.allowCalendarIntegration = this.calendarControllerService.allowCalendarIntegration();

        this.queryMetaData = queryMetaData;
        this.calendarReference = calendarRef;
        // this.examiner = examiner;

        if (this.allowCalendarIntegration) {
          this.setupCalendarConfig();

          // If we have the calendar reference is setup, we can setup the calendars
          if (this.calendarReference?.CalendarIsSetup) {
            this.loadAllCalendars(true);

            return;
          }
        }

        this.initComplete = true;

        // Otherwise, we go ahead and load events
        this.loadEventRange(this.options.startDate);
      });
  }

  // getCurrentCalendarRef(): Observable<CalendarReferenceEntity> {
  //   return this.examinerRepositoryService.getCurrentCalendarRef();
  // }

  gotoProfile() {
    this.router.navigate(['settings/profile']);
  }

  gotoCalendar() {
    this.router.navigate([this.calendarControllerService.getCalendarMenu()]);
  }

  private loadAllCalendars(performSearch: boolean = false, clearEvents: boolean = false) {
    this.calendarControllerService.getCalendars()
      .subscribe((calendars) => {
        this.allCalendars = calendars;

        this.setupUsedCalendars();

        // initial search
        if (performSearch) {
          this.loadEventRange(this.options.startDate, clearEvents);

          this.initComplete = true;
        }
      });
  }

  updateCalendarReference() {
    // Clear events so they can be reloaded
    if (!this.calendarReference?.CalendarIsSetup) {
      this.usedCalendars = [];
      this.calendarConfig = {};

      // reload events minus the calendar events
      this.loadEventRange(this.options.startDate, true);
      return;
    }

    this.setupCalendarConfig();

    this.loadAllCalendars(true, true);


    this.setupUsedCalendars();
  }

  private setupUsedCalendars() {
    if (!this.allCalendars || !this.calendarConfig || !this.calendarReference?.CalendarIsSetup) {
      return;
    }

    var calendars: CalendarDTO[] = [];

    let main = this.allCalendars.find(c => c.Id == this.calendarReference?.MainCalendarKey);

    if (!main) {
      main = this.allCalendars.find(c => c.IsPrimary);
    }

    if (main) {
      calendars.push(main);
    }

    for (const id of this.calendarConfig.AdditionalCalendars) {
      const calendar = this.allCalendars.find(c => c.Id == id);

      if (calendar) {
        calendars.push(calendar);
      }
    }

    this.usedCalendars = calendars;
  }

  protected setupCalendarConfig() {

    if (this.calendarReference?.CalendarConfigJSON) {
      this.calendarConfig = this.calendarReference.CalendarConfigJSON as any;
    }

    if (!this.calendarConfig?.AdditionalCalendars) {
      this.calendarConfig = { AdditionalCalendars: [] };
    }

    this.setupUsedCalendars();
  }

  // getCalendarMenu(): string {
  //   return 'calendar';
  // }

  eventClick(event: CalendarClickEvent) {
    this.selectedEvent = event.eventData;

    const calendarData: CalendarExtendedData = event.eventData?.data;

    this.selectedCheckRide = calendarData?.checkride;
    this.selectedBlockItem = calendarData?.scheduleBlock;


    switch (calendarData?.type) {
      case CalendarDataType.checkride:
        this.eventCheckrideClick(event, this.selectedCheckRide);
        return;
      case CalendarDataType.scheduleBlock:
        this.eventScheduleBlockClick(event, this.selectedBlockItem);
        return;
      case CalendarDataType.tempBlock:
        this.eventBlockDateClick(event, calendarData);
        return;
    }

    // Nothing selected so the calendar was clicked
    if (event.eventType == CalendarClickEventType.timeRangeSelected) {
      this.eventTimeRangeSelected(event);
      return;
    }
  }

  addScheduleBlock() {
    if (!this.useBlockBooking) {
      return;
    }

    this.ignoreNextScheduleUpdate = true;

    this.scheduleBlockService.showAddBlockMultipleModal(this.currentBlockDates, this.calendarControllerService.getOwnershipTypeId())
      .subscribe((modalResult) => {

        if (!modalResult.cancelled && modalResult.data) {
          const scheduleBlock: ScheduleBlockEntity = modalResult.data;

          // All events will be reloaded to show the new block
          this.reloadScheudleBlock(scheduleBlock.ScheduleBlockId);

          this.clearTempScheduleBlocks();
        }
      });

    return;
  }

  reloadScheudleBlock(scheduleBlockId: number, scheduleBlockItemId?: number) {
    const eventSearchRequest = this.currentEventSearchRequest;

    if (!this.currentEventSearchRequest) {
      console.warn('No current event search request to reload Checkride Block');
      return;
    }

    const scheduleBlocksOb = this.calendarControllerService.getScheduleBlocks(eventSearchRequest, scheduleBlockId);

    return combineLatest([scheduleBlocksOb])
      .subscribe(([scheduleBlocks]) => {
        // A linked calendar event is converted into a schedule-block event and retained in
        // mainEvents. Remove every cached representation before rebuilding the edited block.
        const isReloadedBlock = (event: CalendarWeekDayEvent) => {
          const scheduleBlock = (event.data as CalendarExtendedData)?.scheduleBlock;

          if (scheduleBlockItemId) {
            return scheduleBlock?.ScheduleBlockItemId === scheduleBlockItemId;
          }

          return scheduleBlock?.ScheduleBlockId === scheduleBlockId;
        };

        const currentBlockEvents = [...this.blockEvents.filter(e => !isReloadedBlock(e))];
        this.calendarItemConvertedEvents = (this.calendarItemConvertedEvents || []).filter(e => !isReloadedBlock(e));
        this.mainEvents = (this.mainEvents || []).filter(e => !isReloadedBlock(e));

        this.blockEvents = [];

        // A move only reloads its affected item. Other items retain their confirmed matches.
        const scheduleBlocksToReload = scheduleBlockItemId
          ? scheduleBlocks.filter(block => block.ScheduleBlockItemId === scheduleBlockItemId)
          : scheduleBlocks;

        this.addScheduleBlockEvents(scheduleBlocksToReload, this.calendarItemConvertedEvents, scheduleBlockItemId);

        this.blockEvents = [...currentBlockEvents, ...this.blockEvents];

        // Append events to the existing events
        this.events = [...this.mainEvents, ...this.blockEvents];
        this.cdr.detectChanges();

        if (scheduleBlockItemId) {
          this.schedulePendingCalendarSyncRefreshes(
            scheduleBlockId,
            scheduleBlockItemId,
            { ...eventSearchRequest }
          );
        }
      });
  }

  private schedulePendingCalendarSyncRefreshes(
    scheduleBlockId: number,
    scheduleBlockItemId: number,
    eventSearchRequest: EventSearchRequestDTO
  ): void {
    this.clearPendingCalendarSyncRefreshes(scheduleBlockItemId);

    const firstRetry = setTimeout(
      () => this.refreshPendingCalendarSync(scheduleBlockId, scheduleBlockItemId, eventSearchRequest, false),
      20 * 1000
    );
    const secondRetry = setTimeout(
      () => this.refreshPendingCalendarSync(scheduleBlockId, scheduleBlockItemId, eventSearchRequest, false),
      40 * 1000
    );
    const finalRetry = setTimeout(
      () => this.refreshPendingCalendarSync(scheduleBlockId, scheduleBlockItemId, eventSearchRequest, true),
      60 * 1000
    );

    this.pendingCalendarSyncRefreshes.set(scheduleBlockItemId, [firstRetry, secondRetry, finalRetry]);
  }

  private clearPendingCalendarSyncRefreshes(scheduleBlockItemId: number): void {
    const timers = this.pendingCalendarSyncRefreshes.get(scheduleBlockItemId) || [];
    timers.forEach(timer => clearTimeout(timer));
    this.pendingCalendarSyncRefreshes.delete(scheduleBlockItemId);
  }

  private refreshPendingCalendarSync(
    scheduleBlockId: number,
    scheduleBlockItemId: number,
    eventSearchRequest: EventSearchRequestDTO,
    isFinalAttempt: boolean
  ): void {
    const isPending = this.events.some(event =>
      event.calendarSyncPending &&
      (event.data as CalendarExtendedData)?.scheduleBlock?.ScheduleBlockItemId === scheduleBlockItemId
    );

    if (!isPending) {
      this.clearPendingCalendarSyncRefreshes(scheduleBlockItemId);
      return;
    }

    const calendarItemsOb = this.calendarControllerService.getCalendarEvents(eventSearchRequest);
    const scheduleBlocksOb = this.calendarControllerService.getScheduleBlocks(eventSearchRequest, scheduleBlockId);

    combineLatest([calendarItemsOb, scheduleBlocksOb])
      .subscribe(([calendarItems, scheduleBlocks]) => {
        const targetBlocks = scheduleBlocks.filter(block => block.ScheduleBlockItemId === scheduleBlockItemId);
        const freshCalendarEvents = this.convertEvents(calendarItems);
        const matchingCalendarEvents = freshCalendarEvents.filter(event =>
          targetBlocks.some(block => this.isScheduleBlockEventMatch(event, block))
        );

        if (matchingCalendarEvents.length === 0) {
          if (isFinalAttempt) {
            // Force Angular/DayPilot to refresh the still-pending item without implying success.
            this.events = [...this.events];
            this.cdr.detectChanges();
            this.clearPendingCalendarSyncRefreshes(scheduleBlockItemId);
          }
          return;
        }

        const isTargetItem = (event: CalendarWeekDayEvent) =>
          (event.data as CalendarExtendedData)?.scheduleBlock?.ScheduleBlockItemId === scheduleBlockItemId;

        const retainedBlockEvents = this.blockEvents.filter(event => !isTargetItem(event));
        this.calendarItemConvertedEvents = [
          ...(this.calendarItemConvertedEvents || []).filter(event => !isTargetItem(event)),
          ...matchingCalendarEvents
        ];
        this.mainEvents = [
          ...(this.mainEvents || []).filter(event => !isTargetItem(event)),
          ...matchingCalendarEvents
        ];

        this.blockEvents = [];
        this.addScheduleBlockEvents(targetBlocks, matchingCalendarEvents);
        this.blockEvents = [...retainedBlockEvents, ...this.blockEvents];
        this.events = [...this.mainEvents, ...this.blockEvents];
        this.cdr.detectChanges();
        this.clearPendingCalendarSyncRefreshes(scheduleBlockItemId);
      });
  }

  clearTempScheduleBlocks() {
    this.tempBlockEvents = [];
    this.currentBlockDates = [];
    this.events = [...this.mainEvents, ...this.blockEvents];

    this.calendar?.clearSelection();
  }

  removeTempBlock(blockDate: ScheduleBlockDateRef) {
    this.tempBlockEvents = this.tempBlockEvents.filter(e => !areEqual(e.data.blockDate, blockDate));

    this.currentBlockDates = this.currentBlockDates.filter(d => !areEqual(d, blockDate));

    this.events = [...(this.mainEvents || []), ...this.blockEvents, ...this.tempBlockEvents];

    this.calendar?.clearSelection();
  }

  currentBlockDates: ScheduleBlockDateRef[] = [];

  eventTimeRangeSelected(event: CalendarClickEvent) {

    this.createTempScheduleBlock(event.start, event.end);
  }



  createTempScheduleBlock(start: any, end: any) {
    if (!this.useBlockBooking) {
      // Default to original functionality
      this.addNewCheckride(start, end);
      return;
    }

    // Create a new block booking
    const blockDate = this.scheduleBlockService.parseBlockStartEndDates(start, end);

    if (!blockDate) {
      return;
    }

    this.currentBlockDates.push(blockDate);

    this.tempBlockEvents.push({
      id: `tempBlock:${this.tempBlockEvents.length + 1}`,
      text: 'Temp Block (Unsaved)',
      barColor: 'orange',
      start: start,
      end: end,
      data: {
        type: CalendarDataType.tempBlock,
        blockDate: blockDate
      }
    });

    this.events = [...(this.mainEvents || []), ...this.blockEvents, ...this.tempBlockEvents];

    this.calendar?.clearSelection();
  }

  eventScheduleBlockClick(event: CalendarClickEvent, selectedBlockItem: ScheduleBlockCalendarEvent) {
    switch (event.eventType) {
      case CalendarClickEventType.moved:
      case CalendarClickEventType.resized:

        this.moveScheduleBlockEvent(event, selectedBlockItem);

        return;
      case CalendarClickEventType.click:
      case CalendarClickEventType.doubleClick:
      case CalendarClickEventType.selected:
        break;

      case CalendarClickEventType.timeRangeSelected:
      default:
        return;
    }

    this.editScheduleBlock(selectedBlockItem);
  }

  eventBlockDateClick(event: CalendarClickEvent, calendarData: CalendarExtendedData) {
    switch (event.eventType) {
      case CalendarClickEventType.moved:
        this.removeTempBlock(calendarData.blockDate);

        this.createTempScheduleBlock(event.eventData?.start, event.eventData?.end);

        return;
      case CalendarClickEventType.click:
      case CalendarClickEventType.doubleClick:
      case CalendarClickEventType.selected:
        //  this.removeTempBlock(calendarData.blockDate);
        break;

      case CalendarClickEventType.timeRangeSelected:
      default:
        return;
    }

    this.removeTempBlock(calendarData.blockDate);
  }


  moveScheduleBlockEvent(event: CalendarClickEvent, selectedBlockItem: ScheduleBlockCalendarEvent) {
    if (this.selectedBlockItem.ScheduleBlockItemTypeId == ScheduleBlockItemTypeAllItems.DateRange) {
      this.editScheduleBlock(selectedBlockItem);
      return;
    }

    var startDate = (event.eventData.start as any)?.value;
    var endDate = (event.eventData.end as any)?.value;

    if (!startDate || !endDate) {
      return;
    }

    this.ignoreNextScheduleUpdate = true;

    this.calendar?.clearSelection();

    this.scheduleBlockService.moveScheduleBlockItem(selectedBlockItem.ScheduleBlockItemId, startDate, endDate)
      .subscribe(() => {


        // reload events
        this.reloadScheudleBlock(selectedBlockItem.ScheduleBlockId, selectedBlockItem.ScheduleBlockItemId);

      });
  }

  addNewScheduleBlock(start: any, end: any) {

    this.scheduleBlockService.showAddBlockModal(start, end, this.calendarControllerService.getOwnershipTypeId())
      .subscribe(() => {

      });

    return;
  }

  editScheduleBlock(selectedBlockItem: ScheduleBlockCalendarEvent) {
    this.ignoreNextScheduleUpdate = true;

    this.scheduleBlockService.showEditBlockModal(selectedBlockItem, this.calendarControllerService.getOwnershipTypeId())
      .subscribe((modalResult) => {
        if (!modalResult.cancelled) {
          this.reloadScheudleBlock(selectedBlockItem.ScheduleBlockId);
        }
      });

    //    this.router.navigate([`${this.getCalendarMenu()}/schedule-block/edit`, selectedBlockItem?.ScheduleBlockId]);
  }

  eventCheckrideClick(event: CalendarClickEvent, CheckRideRequest: CheckRideRequestCalendarQueryEntity) {

    switch (event.eventType) {
      case CalendarClickEventType.moved:
      case CalendarClickEventType.click:
      case CalendarClickEventType.doubleClick:
      case CalendarClickEventType.selected:
        break;
      case CalendarClickEventType.resize:
        event.preventDefault();
        return;

      case CalendarClickEventType.timeRangeSelected:
      default:
        return;
    }

    if (!this.selectedCheckRide) {
      return;
    }

    if (event.eventType == CalendarClickEventType.moved) {
      const rescheduleInfo: CheckrideReferenceInfo = {
        proposedStartDateTime: event.eventData.start.toString()
      };

      this.calendarControllerService.setCheckrideReferenceInfo(this.selectedCheckRide.CheckRideRequestId, rescheduleInfo);

      // reset the event dates back to the original (if it is updated, we'll reload and move it on the calendar)
      this.setCheckrideEventDates(this.selectedEvent, this.selectedCheckRide);

      this.events = [...this.events];
    }

    this.router.navigate([`${this.calendarControllerService.getCalendarMenu()}/edit`, this.selectedCheckRide.CheckRideRequestId]);
  }

  addNewCheckride(start?: any, end?: any) {
    if (start == null || end == null) {
      if (this.currentBlockDates.length == 1) {
        start = this.currentBlockDates[0].fullStartDateTime
        end = this.currentBlockDates[0].fullEndDateTime
      } else {
        return;
      }
    }

    const startUtcDateTime = this.dateTimeUtilService.convertDateTimeToUtc(start);
    const endUtcDateTime = this.dateTimeUtilService.convertDateTimeToUtc(end);

    const durationMinutes = this.dateTimeUtilService.calcDurationMinutes(startUtcDateTime, endUtcDateTime, 30, 30, 60 * 8);
    const rescheduleInfo: CheckrideReferenceInfo = {
      startDateTime: startUtcDateTime,
      durationMinutes: durationMinutes
    };

    this.calendarControllerService.setCheckrideReferenceInfo(-1, rescheduleInfo);

    const url = `${this.calendarControllerService.getCalendarMenu()}/add`;
    //const url = `calendar/add?ScheduleDateTime=${startUtcDateTime}&ScheduledTimeMinutes=${durationMinutes}`
    this.router.navigateByUrl(url);
  }




  handleDateChange(date: DateTimeModel) {
    for (const request of this.eventSearchRequests) {
      if (this.isWithinRange(request, date, true)) {
        // we're finished
        return;
      }
    }

    // load dates for month
    this.loadEventRange(date.toString(false));
  }

  isWithinRange(request: EventSearchRequestDTO, date: DateTimeModel | string, checkExactDate: boolean = false): boolean {
    const startDate = getMomentValue(request.StartDateTime, false, false);
    const endDate = getMomentValue(request.EndDateTime, false, false);

    const refDate = date.toString(false);

    if (checkExactDate) {
      const refDateMoment = getMomentValue(refDate, false, false);

      if (startDate.isSameOrBefore(refDateMoment, 'day') && endDate.isSameOrAfter(refDateMoment, 'day')) {
        // We're within range, nothing to do
        return true;
      }

      return false;
    }

    // Compare Sunday throught Saturday since we display events for the entire week
    const monthStart = this.getMonthStart(refDate);
    const monthEnd = this.getMonthEnd(refDate);

    if (startDate.isSameOrBefore(monthStart, 'day') && endDate.isSameOrAfter(monthEnd, 'day')) {
      // We're within range, nothing to do
      return true;
    }

    return false;
  }

  protected loadEventRange(refDate: string = null, clearEvents: boolean = false) {

    // Clear search events so the dates will be calculated correctly
    if (clearEvents) {
      this.eventSearchRequests = [];
      this.blockEvents = [];
    }

    let monthStart = this.getMonthStart(refDate);
    let monthEnd = this.getMonthEnd(refDate);

    monthStart = this.adjustMonthStart(monthStart);
    monthEnd = this.adjustMonthEnd(monthEnd);

    const eventSearchRequest: EventSearchRequestDTO = {
      CalendarId: this.calendarReference?.MainCalendarKey,
      AdditionalCalendars: this.calendarConfig?.AdditionalCalendars || [],
      StartDateTime: convertToIsoDateTime(monthStart.format('MM/DD/YYYY'), false),
      EndDateTime: convertToIsoDateTime(monthEnd.format('MM/DD/YYYY'), false),
    };

    this.eventSearchRequests.push(eventSearchRequest);

    this.currentEventSearchRequest = eventSearchRequest;

    let calendarItemsOb = of([]);
    const checkRidesOb = this.calendarControllerService.getCheckrides(eventSearchRequest, this.queryMetaData);

    if (this.allowCalendarIntegration && this.calendarReference?.CalendarIsSetup) {
      const finalEventSearchRequest: EventSearchRequestDTO = {
        ...eventSearchRequest,
        EndDateTime: convertToIsoDateTime(monthEnd.add(1, 'days').format('MM/DD/YYYY'), false)
      };

      calendarItemsOb = this.calendarControllerService.getCalendarEvents(finalEventSearchRequest);
    }

    const scheduleBlocksOb = this.calendarControllerService.getScheduleBlocks(eventSearchRequest);

    combineLatest([calendarItemsOb, checkRidesOb, scheduleBlocksOb])
      .subscribe(([calendarItems, checkRides, scheduleBlocks]) => {
        const convertedEvents = this.convertEvents(calendarItems);
        this.calendarItemConvertedEvents = convertedEvents;

        this.addCheckRidesEvents(checkRides, convertedEvents);

        this.addScheduleBlockEvents(scheduleBlocks, convertedEvents);

        if (clearEvents) {
          this.events = [];
        }

        this.mainEvents = [...this.events, ...this.calendarItemConvertedEvents]

        // Append events to the existing events
        this.events = [...this.mainEvents, ...this.blockEvents];

        this.cdr.detectChanges();

        this.initLoadComplete = true;
      });
  }

  blockEvents: any[] = [];

  addScheduleBlockEvents(scheduleBlocks: ScheduleBlockCalendarEvent[], convertedEvents: CalendarWeekDayEvent[], pendingScheduleBlockItemId?: number) {
    this.blockEvents = [];

    for(const scheduleBlock of scheduleBlocks) {
      let existingCalendarEvent: CalendarWeekDayEvent;

      existingCalendarEvent = convertedEvents.find(e => this.isScheduleBlockEventMatch(e, scheduleBlock));

      const event = this.convertScheduleBlock(scheduleBlock, existingCalendarEvent);

      this.setCalendarSyncPendingIndicator(
        event,
        !existingCalendarEvent && scheduleBlock.ScheduleBlockItemId === pendingScheduleBlockItemId
      );

      const finalEvents = this.scheduleBlockService.adjustScheduleBlock(event, convertedEvents);

      // only add if there isn't a calendar event already
      if (!existingCalendarEvent && finalEvents.length > 0) {
        this.blockEvents = [...this.blockEvents, ...finalEvents];
      }
    }
  }

  isScheduleBlockEventMatch(e: CalendarWeekDayEvent, scheduleBlock: ScheduleBlockCalendarEvent): unknown {
    const calendarData: CalendarExtendedData = e?.data;
    if (calendarData?.type != CalendarDataType.calendarEvent) {
      return false;
    }

    const calendarEvent = calendarData?.calendarEvent as CalendarEventDTO;

    if (calendarEvent?.EventType !== 'ScheduleBlock') {
      return false;
    }

    const scheduleBlockItemKey = scheduleBlock.ScheduleBlockItemId.toString();
    const eventKeyMatches = calendarEvent?.EventKey === scheduleBlockItemKey ||
      calendarEvent?.EventKey?.startsWith(`${scheduleBlockItemKey}:`);

    if (!eventKeyMatches) {
      return false;
    }

    if (scheduleBlock.ScheduleBlockItemTypeId == ScheduleBlockItemTypeAllItems.IndividualDay) {
      // Individual days should always be a direct match
      return true;
    }

    // Match a date range block which might span multiple times a day and multiple days per week
    // Check if start and end dates are within the match
    const eventStart = getMomentValue(e.start, true, true);
    const eventEnd = getMomentValue(e.end, true, true);
    const blockStart = getMomentValue(scheduleBlock.Start, true, true);
    const blockEnd = getMomentValue(scheduleBlock.End, true, true);

    if (eventStart.isSame(blockStart, 'minute') && eventEnd.isSame(blockEnd, 'minute')) {
      return true;
    }

    return false;
  }

  scheduleBlockColor = 'blue';

  private setLinkedCalendarIndicator(event: CalendarWeekDayEvent, isLinked: boolean): void {
    const linkedCalendarAreaId = 'linked-calendar-event';

    event.linkedCalendarEvent = isLinked;
    event.areas = (event.areas || []).filter(area => area.id !== linkedCalendarAreaId);

    if (isLinked) {
      event.areas.push({
        id: linkedCalendarAreaId,
        right: 3,
        bottom: 3,
        width: 18,
        height: 18,
        html: '<i class="fas fa-calendar-check" aria-hidden="true"></i>',
        toolTip: 'Linked to your calendar',
        action: 'None',
        style: 'display:flex;align-items:center;justify-content:center;border-radius:3px;background:rgba(0,0,0,.25);color:#fff;font-size:12px;'
      });
    }
  }

  private setCalendarSyncPendingIndicator(event: CalendarWeekDayEvent, isPending: boolean): void {
    const calendarSyncPendingAreaId = 'calendar-sync-pending';

    event.calendarSyncPending = isPending;
    event.areas = (event.areas || []).filter(area => area.id !== calendarSyncPendingAreaId);

    if (isPending) {
      event.areas.push({
        id: calendarSyncPendingAreaId,
        right: 3,
        bottom: 3,
        width: 18,
        height: 18,
        html: '<i class="fas fa-clock" aria-hidden="true"></i>',
        toolTip: 'Calendar sync pending',
        action: 'None',
        style: 'display:flex;align-items:center;justify-content:center;border-radius:3px;background:rgba(0,0,0,.25);color:#ffc107;font-size:12px;'
      });
    }
  }

  convertScheduleBlock(scheduleBlock: ScheduleBlockCalendarEvent, existingCalendarEvent: CalendarWeekDayEvent): CalendarWeekDayEvent {
    const parts: string[] = [];

    parts.push(`${scheduleBlock.ScheduleBlockName || 'Checkride Block'}`);

    const displayOptions = this.calendarControllerService.getEventDisplayOptions();

    if (scheduleBlock.FlightSchoolName && displayOptions.showSchool) {
      parts.push(`Flight School: ${scheduleBlock.FlightSchoolName}`);
    }

    if (scheduleBlock.ExaminerName && displayOptions.showExaminer) {
      parts.push(`Examiner: ${scheduleBlock.ExaminerName}`);
    }

    if (scheduleBlock.Airports) {
      parts.push(`Airports: ${scheduleBlock.Airports}`);
    }

    if (scheduleBlock.CheckRideTypes) {
      parts.push(`Checkride Types: ${scheduleBlock.CheckRideTypes}`);
    }

    // if (scheduleBlock.BookingTimeZone) {
    //   parts.push(`Timezone: ${scheduleBlock.BookingTimeZone}`);
    // }
    //parts.push(`Description: ${scheduleBlock.Description}`);

    const eventText = parts.join('\n');

    const updateColors = !existingCalendarEvent || true; // Force colors to update for now

    const event: CalendarWeekDayEvent = existingCalendarEvent || {
      id: `scheduleBlock:${scheduleBlock.ScheduleBlockItemId}`,
      text: eventText,
    } as any;

    event.text = eventText;

    const calendarData: CalendarExtendedData = {
      type: CalendarDataType.scheduleBlock,
      scheduleBlock: scheduleBlock,
      startDateTime: this.convertDateTime(scheduleBlock.Start),
      endDateTime: this.convertDateTime(scheduleBlock.End)
    };

    event.data = calendarData;

    event.start = this.convertDateTime(scheduleBlock.Start);
    event.end = this.convertDateTime(scheduleBlock.End);
    if (updateColors) {
      event.barColor = this.scheduleBlockColor;
      event.backColor = scheduleBlock.BackgroundColor || this.scheduleBlockColor;
      event.fontColor = scheduleBlock.ForegroundColor || '#ffffff';
    }

    event.moveDisabled = true;

    this.setLinkedCalendarIndicator(event, !!existingCalendarEvent);

    if (scheduleBlock.ScheduleBlockItemTypeId == ScheduleBlockItemTypeAllItems.IndividualDay) {
      event.moveDisabled = false;
    }

    event.bubbleHtml = this.buildScheduleBlockBubble(scheduleBlock, !!existingCalendarEvent);

    return event;
  }

  buildScheduleBlockBubble(scheduleBlock: ScheduleBlockCalendarEvent, isLinkedToCalendar: boolean = false): string {

    const parts: string[] = [];


    const displayOptions = this.calendarControllerService.getEventDisplayOptions();

    if (scheduleBlock.ScheduleBlockItemTypeIdDisplay) {
      parts.push(`Type: ${scheduleBlock.ScheduleBlockItemTypeIdDisplay}`);
    }

    if (scheduleBlock.FlightSchoolName && displayOptions.showSchool) {
      parts.push(`Flight School: ${scheduleBlock.FlightSchoolName}`);
    }

    if (scheduleBlock.ExaminerName && displayOptions.showExaminer) {
      parts.push(`Examiner: ${scheduleBlock.ExaminerName}`);
    }

    if (scheduleBlock.CheckRideTypes) {
      parts.push(`Checkride Types: ${scheduleBlock.CheckRideTypes}`);
    }

    if (scheduleBlock.Airports) {
      parts.push(`Airports: ${scheduleBlock.Airports}`);
    }

    if (scheduleBlock.BookingTimeZone) {
      parts.push(`Timezone: ${scheduleBlock.BookingTimeZone}`);
    }
    parts.push(`Description: ${scheduleBlock.Description}`);

    if (isLinkedToCalendar) {
      parts.push('Calendar: Linked');
    }

    const rows: string[] = [];

    for (const fieldData of parts) {
      const row = `<div class="bubble-content">${fieldData}</div>`

      rows.push(row)
    }

    return `<div class="bubble"><div class="bubble-title">${scheduleBlock.ScheduleBlockName || 'Checkride Block'} (${scheduleBlock.ScheduleBlockItemId})</div>${rows.join('')}</div>`;
  }

  //   protected getCheckrides(eventSearchRequest: EventSearchRequestDTO): Observable < CheckRideRequestCalendarQueryEntity[] > {
  //   return this.examinerRepositoryService.getCheckRidesRequests(this.queryMetaData, eventSearchRequest.StartDateTime, eventSearchRequest.EndDateTime);
  // }

  protected getMonthStart(refDate: string): moment_.Moment {
    return getMomentValue(refDate, false, false).startOf('month').startOf('week');
  }

  protected getMonthEnd(refDate: string): moment_.Moment {
    return getMomentValue(refDate, false, false).startOf('month').startOf('week').add(5, 'weeks').endOf('week');
  }

  protected adjustMonthStart(refDate: moment_.Moment): moment_.Moment {
    const searchRequest = this.eventSearchRequests.find(r => this.isWithinRange(r, refDate.toISOString(), true));

    if (!searchRequest) {
      return refDate;
    }

    // use end date plus 1 day of search request
    const endDate = getMomentValue(searchRequest.EndDateTime, false, false).add(1, 'days');;

    return endDate;
  }

  protected adjustMonthEnd(refDate: moment_.Moment): moment_.Moment {
    const searchRequest = this.eventSearchRequests.find(r => this.isWithinRange(r, refDate.toISOString(), true));

    if (!searchRequest) {
      return refDate;
    }

    // use start date minus one day of search request
    const endDate = getMomentValue(searchRequest.StartDateTime, false, false).add(-1, 'days');

    return endDate;
  }

  addCheckRidesEvents(checkRides: CheckRideRequestCalendarQueryEntity[], convertedEvents: CalendarWeekDayEvent[]) {
    checkRides.forEach(cr => {

      const existingCalendarEvent = convertedEvents.find(e => this.isCheckrideEventMatch(e, cr));

      const event = this.convertCheckRideEvent(cr, existingCalendarEvent);

      // only add if there isn't a calendar event already
      if (!existingCalendarEvent) {
        convertedEvents.push(event);
      }

    });
  }

  private isCheckrideEventMatch(event: CalendarWeekDayEvent, checkride: CheckRideRequestCalendarQueryEntity): boolean {
    if (checkride.CalendarEventReferenceKey && event.id === checkride.CalendarEventReferenceKey) {
      return true;
    }

    const calendarEvent = (event.data as CalendarExtendedData)?.calendarEvent as CalendarEventDTO;
    if (calendarEvent?.EventType !== 'Checkride' || calendarEvent?.EventKey !== checkride.CheckRideRequestId.toString()) {
      return false;
    }

    let checkrideStart = checkride.ScheduledDateTime;
    if (checkride.CheckRideRequestSubStatusId === CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer) {
      checkrideStart = checkride.ProposedDateTime;
    }

    const eventStart = getMomentValue(event.start, true, true);
    const expectedStart = getMomentValue(this.convertDateTime(checkrideStart), true, true);

    return eventStart.isSame(expectedStart, 'minute');
  }

  convertCheckRideEvent(cr: CheckRideRequestCalendarQueryEntity, existingCalendarEvent: CalendarWeekDayEvent): CalendarWeekDayEvent {
    //const start = convertToIsoDateTime(formatDateTimeToLocal(cr.ScheduledDateTime, true, true), true);

    const checkRideColor = this.getCheckRideColor(cr)

    const eventText = this.buildCheckrideEventText(cr);

    const event: CalendarWeekDayEvent = existingCalendarEvent || {
      id: `checkRideId:${cr.CheckRideRequestId}`,
      text: eventText, // `Checkride: ${cr.ApplicantNameApplicantFinalName || 'Not Set'}\nStatus: ${cr.CheckRideRequestSubStatusIdDisplay}`,
      // start: start,
      // end: this.computeEndDateTime(start, cr.ScheduledTimeMinutes),
      barColor: checkRideColor,
    } as any;

    event.text = eventText;

    this.setCheckrideEventDates(event, cr);

    const calendarData: CalendarExtendedData = {
      type: CalendarDataType.checkride,
      checkride: cr,
      startDateTime: event.start,
      endDateTime: event.end
    };

    event.data = calendarData;

    event.backColor = checkRideColor;
    event.fontColor = '#ffffff';
    event.moveDisabled = false;

    this.setLinkedCalendarIndicator(event, !!existingCalendarEvent);

    event.bubbleHtml = this.buildBubble(cr, !!existingCalendarEvent);



    return event;
  }

  protected buildCheckrideEventText(cr: CheckRideRequestCalendarQueryEntity): string {
    var parts = this.buildCheckrideDisplayParts(cr, false);

    parts = ['Checkride'].concat(parts);

    return parts.join('\n');
  }


  protected buildCheckrideDisplayParts(cr: CheckRideRequestCalendarQueryEntity, includeFullDetails: boolean): string[] {
    var parts = [];

    const fields = AppMetaData.Queries.CheckRideRequestCalendar.Attributes;

    const displayOptions = this.calendarControllerService.getEventDisplayOptions();

    this.addField(parts, cr, fields.ApplicantNameApplicantFinalName);

    const inProposedStatus = cr.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer;

    this.addField(parts, cr, fields.CheckRideRequestSubStatusId);

    if (displayOptions.showExaminer) {
      this.addField(parts, cr, fields.ApplicantNamePilotExaminerFinalName, 'Examiner')
    }

    if (displayOptions.showSchool) {
      this.addField(parts, cr, fields.ApplicantNameFlightSchoolFinalName, 'Flight School')
    }

    if (inProposedStatus) {
      this.addField(parts, cr, fields.ProposedAirportId, 'Proposed Airport', fields.ScheduledAirportId);
    } else {
      this.addField(parts, cr, fields.ScheduledAirportId);
    }

    if (includeFullDetails) {
      this.addField(parts, cr, fields.CheckRideGroupId);
      this.addField(parts, cr, fields.CheckRideTypeId);
      this.addField(parts, cr, fields.CheckRideTestTypeId);
      this.addField(parts, cr, fields.AuthorityPreCheckRideNumber);
    }

    this.addField(parts, cr, fields.AuthorityApprovalCode, null, null, 'Not Set', !includeFullDetails);

    this.addField(parts, cr, fields.ApplicantNameApplicantFinalPhone);

    return parts;
  }

  setCheckrideEventDates(event: CalendarWeekDayEvent, checkride: CheckRideRequestCalendarQueryEntity) {
    let startDate = checkride.ScheduledDateTime;

    if (checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer) {
      startDate = checkride.ProposedDateTime;
    }

    const start = this.convertDateTime(startDate);

    event.start = start;
    event.end = this.computeEndDateTime(start, checkride.ScheduledTimeMinutes);
  }


  protected buildBubble(cr: CheckRideRequestCalendarQueryEntity, isLinkedToCalendar: boolean = false): string {

    var parts = this.buildCheckrideDisplayParts(cr, true);

    if (isLinkedToCalendar) {
      parts.push('Calendar: Linked');
    }

    const rows: string[] = [];

    for (const fieldData of parts) {
      const row = `<div class="bubble-content">${fieldData}</div>`

      rows.push(row)
    }

    return `<div class="bubble"><div class="bubble-title">Checkride</div>${rows.join('')}</div>`;
  }


  private buildDataRow(cr: CheckRideRequestCalendarQueryEntity, field: string): string {
    const attr = this.queryMetaData.Attributes.find(a => a.AttributeName == field);

    if (attr) {
      return `<div class="bubble-content">${attr.AttributeDisplay}: ${cr[attr.DisplayAttributeName]}</div>`;
    }
  }

  private addField(fields: string[], cr: CheckRideRequestCalendarQueryEntity, field: string | DwItemAttribute, captionOverride?: string, altField?: string | DwItemAttribute, noDataText: string = 'Not Set', hideIfNoData: boolean = false) {
    let fieldInfo = this.getFieldData(cr, field, noDataText);
    let altFieldInfo = this.getFieldData(cr, altField, noDataText);

    if (!fieldInfo?.data && altFieldInfo) {
      fieldInfo = altFieldInfo;
    }

    if (fieldInfo) {

      if (!fieldInfo.data && hideIfNoData) {
        return;
      }
      const text = `${captionOverride || fieldInfo.attr.AttributeDisplay}: ${fieldInfo.displayData}`;

      fields.push(text);
    }
  }


  //   if (field instanceof DwItemAttribute) {
  //     field = field.fieldName;
  //   }

  //   if (altField instanceof DwItemAttribute) {
  //     altField = altField.fieldName;
  //   }

  //   const attr = this.queryMetaData.Attributes.find(a => a.AttributeName == field);
  //   const altAttr = this.queryMetaData.Attributes.find(a => a.AttributeName == altField);

  //   if (attr) {
  //     const data = cr[attr.DisplayAttributeName] || 'Not Set';

  //     const text = `${ captionOverride || attr.AttributeDisplay}: ${data}`;
  //     fields.push(text);
  //   }
  // }

  private getFieldData(cr: CheckRideRequestCalendarQueryEntity, field: string | DwItemAttribute, noDataText: string = 'Not Set'): { attr: DwQueryMdAttribute, data: string, displayData: string } {
    if (field instanceof DwItemAttribute) {
      field = field.fieldName;
    }

    const attr = this.queryMetaData.Attributes.find(a => a.AttributeName == field);

    if (attr) {

      let data = cr[attr.DisplayAttributeName];

      if (data?.length == 0) {
        data = null;
      }
      return {
        attr: attr,
        data: data,
        displayData: data || noDataText,

      };
    }

    return null;
  }

  requiresActionEventColor = '#ffa500';
  noActionRequiredEventColor = 'green';

  getCheckRideColor(cr: CheckRideRequestCalendarQueryEntity) {
    switch (cr.CheckRideRequestSubStatusId) {
      case CheckRideRequestSubStatusAllItems.PendingApproval:
      case CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer:
      case CheckRideRequestSubStatusAllItems.PendingOutcome:
      case CheckRideRequestSubStatusAllItems.AcceptedPendingPayment:
      case CheckRideRequestSubStatusAllItems.AdditionalInformationNeeded:
      case CheckRideRequestSubStatusAllItems.RequiresAdditionalInfo:
      case CheckRideRequestSubStatusAllItems.PendingPayment:
        return this.requiresActionEventColor;
      default:
        return this.noActionRequiredEventColor;
    }
  }

  computeEndDateTime(ScheduledDateTime: string, ScheduledTimeMinutes: number) {
    const start = getMomentValue(ScheduledDateTime, true, true);

    const end = start.add(ScheduledTimeMinutes, 'minutes');

    return end.toISOString();
  }

  convertEvents(events: CalendarEventDTO[]): CalendarWeekDayEvent[] {

    return events.map(e => this.convertEvent(e))
      // remove blank events
      .filter(e => e);
  }

  private convertDateTime(value: string): string {
    if (!value) {
      return value;
    }


    //let momentValue = getMomentValue(value, true, true);

    const localTime = formatDateTimeToLocal(value, true, true);

    let momentValue = getMomentValue(localTime, true, true);

    //momentValue.add(-5, 'hours');

    let convertedDateTime = momentValue.toISOString(true);

    return convertedDateTime;
  }

  convertEvent(e: CalendarEventDTO): CalendarWeekDayEvent {
    let calendar = this.allCalendars.find(c => c.Id == e.CalendarId);

    if (!calendar) {
      calendar = this.allCalendars.find(c => c.Id == this.calendarReference?.MainCalendarKey);
    }

    const calendarData: CalendarExtendedData = {
      type: CalendarDataType.calendarEvent,
      calendarEvent: e,
      startDateTime: this.convertEventDateTime(e.Start),
      endDateTime: this.convertEventDateTime(e.End)
    };

    const event: CalendarWeekDayEvent = {
      id: e.Id,
      text: e.Name,
      start: this.convertEventDateTime(e.Start),
      end: this.convertEventDateTime(e.End),
      barColor: calendar.Color?.BackgroundColor,
      allday: e.AllDayEvent,
      moveDisabled: true,
      data: calendarData,
    };

    switch (e.Status) {
      case CalendarEventStatus.cancelled:
        return null;
      case CalendarEventStatus.tenative:
        event.text = `${event.text} (Tentative)`
        break;
    }

    if (e.AllDayEvent) {
      event.allday = false;

      event.start = this.convertEventDateTime(e.Start, '00:00')
      event.end = this.convertEventDateTime(e.End, '23:59')
    }

    if (e.Color) {
      event.fontColor = e.Color.ForegroundColor;
      event.backColor = e.Color.BackgroundColor
    } else {
      event.fontColor = this.getForegroundColor(calendar.Color?.ForegroundColor);
      event.backColor = calendar.Color?.BackgroundColor;
    }

    event.fontColor = this.getForegroundColor(event.fontColor);

    if (event.barColor == event.backColor) {
      event.barColor = '#ffffff';
    }

    event.bubbleHtml = `<div class="bubble"><div class="bubble-title">${e.Name}</div>`;

    if (e.Description) event.bubbleHtml += `<div class="bubble-content">${e.Description}</div>`

    this.bubbleTestHtml = event.bubbleHtml;

    if (e.Transparency) {
      event.text = `${event.text} (Free)`
      event.bubbleHtml += `<div class="bubble-content">Event is marked as Free time</div>`
    }

    if (e.HtmlLink) {
      const htmlId = e.HtmlLink.split('eid=')[1];
      const linkUrl = `https://calendar.google.com/calendar/u/1/r/eventedit/${htmlId}`;

      event.bubbleHtml += `<br><a href='${linkUrl}' target='_blank'>View in Google Calendar</a>`;
    }

    event.bubbleHtml += `</div>`

    return event;
  }

  private getForegroundColor(color: string): string {
    return '#fff';

  }

  private convertEventDateTime(eventDate: EventDateTimeDTO, forceTimeForDateOnly?: string): string {

    if (eventDate.DateTimeLocalRaw) {
      return eventDate.DateTimeLocalRaw;
    }

    if (eventDate?.DateTime) {
      return convertToIsoDateTime(formatDateTimeToLocal(eventDate.DateTimeRaw, true, true), true);
    }

    if (eventDate?.Date) {
      let date = eventDate.Date;

      if (forceTimeForDateOnly) {
        date = `${date} ${forceTimeForDateOnly}`;
      }

      return convertToIsoDateTime(formatDateTimeToLocal(date, true, true), true);
    }

    return null;
  }


  private setCalendarOptions() {
    this.options = {
      startDate: convertToIsoDateTime(moment().format("MM/DD/YYYY"), false),
    };

  };

}
